<div class="set-up-threshold">
  <div class="main-title">
    <div class="title">Set up threshold</div>
    <div class="sub-title">Enter the percent above/below the historical
      average that will be considered warning and critical
    </div>
  </div>
  <div class="container">
    <form [formGroup]="historicalThresholdsForm">
      <div class="default-warning">
        <div class="title">{{fromLableName}} *</div>
        <div class="warning-container">
          <div class="default-value">
            <input autocomplete="off" matInput formControlName="from" type="number" required />
          </div>
          <div class="units">%</div>
        </div>
        <div *ngIf="fromCtrl.invalid && (fromCtrl.dirty || fromCtrl.touched)" class="error">
          <ng-container *ngIf="historicalThresholdsForm.hasError('required', 'from')">
            {{getRequiredMessage(fromLableName)}}
          </ng-container>
          <ng-container
            *ngIf="historicalThresholdsForm.hasError('min', 'from') || historicalThresholdsForm.hasError('max', 'from')">
            {{getMinMaxMessage(fromLableName)}}
          </ng-container>
        </div>
      </div>
      <div class="default-critical">
        <div class="title">{{toLableName}} *</div>
        <div class="critical-container">
          <div class="default-value">
            <input autocomplete="off" matInput formControlName="to" type="number" required />
          </div>
          <div class="units">%</div>
        </div>
        <div *ngIf="toCtrl.invalid && (toCtrl.dirty || toCtrl.touched)" class="error">
          <ng-container *ngIf="historicalThresholdsForm.hasError('required', 'to')">
            {{getRequiredMessage(toLableName)}}
          </ng-container>
          <ng-container
            *ngIf="historicalThresholdsForm.hasError('min', 'to') || historicalThresholdsForm.hasError('max', 'to')">
            {{getMinMaxMessage(toLableName)}}
          </ng-container>
        </div>
        <div *ngIf="fromCtrl.valid && toCtrl.valid" class="error">
          <ng-container *ngIf="showErrorMsg()">
            {{getFromToValidMessage()}}
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</div>
